export default () => {
    const menuButton = document.querySelector('.js-toggle-nav')
    const closeButton = document.querySelector('.js-close-menu')
    const navigation = document.querySelector('.js-navigation')
    const links = document.querySelectorAll('.js-navigation-link')
    const body = document.body

    function trackClick (e) {
        if (
            navigation.classList.contains('c-navigation--active') &&
            !e.target.classList.contains('c-burger-button__cross')
        ) {
            if (!navigation.contains(e.target)) {
                navigation.classList.remove('c-navigation--active')
                body.classList.remove('menu-open')
            }
        }
    }

    if (menuButton) {
        menuButton.addEventListener('click', e => {
            if (!navigation.classList.contains('c-navigation--active')) {
                navigation.classList.add('c-navigation--active')
                body.classList.add('menu-open')
            }
        })
    }

    if (links.length) {
        ;[...links].forEach(link => {
            link.addEventListener('click', e => {
                if (navigation.classList.contains('c-navigation--active')) {
                    navigation.classList.remove('c-navigation--active')
                    body.classList.remove('menu-open')
                }
            })
        })
    }
    if (closeButton) {
        closeButton.addEventListener('click', e => {
            if (navigation.classList.contains('c-navigation--active')) {
                navigation.classList.remove('c-navigation--active')
                body.classList.remove('menu-open')
            }
        })
    }
}

// WEBPACK FOOTER //
// ./src/js/modules/DropdownMenu.js
